/**
 * Combat log related types
 */
/**
 * Combat log event types
 */
export var CombatLogEventType;
(function (CombatLogEventType) {
    CombatLogEventType["UNKNOWN"] = "unknown";
    CombatLogEventType["COMBAT_START"] = "combat-start";
    CombatLogEventType["COMBAT_END"] = "combat-end";
    CombatLogEventType["DAMAGE"] = "damage";
    CombatLogEventType["HEAL"] = "heal";
    CombatLogEventType["DEATH"] = "death";
    CombatLogEventType["ABILITY_USED"] = "ability-used";
})(CombatLogEventType || (CombatLogEventType = {}));
